import { type AppInfo } from '../../../types';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from './StatusScreen';

/**
 * "Why didn't it finish?": the answer and Back to the error screen, where
 * Try again and Use another app are. Help answers repeat no actions the
 * screen they came from already has.
 */
export default function EmbeddedWhyScreen({
  app,
  onBack,
}: {
  app?: AppInfo;
  onBack: () => void;
}) {
  const { t, pick } = useEmbeddedCopy();
  return (
    <EmbeddedStatusScreen
      visual="help"
      title={t('embedded.why.title')}
      sub={t(pick('embedded.why.sub', 'embedded.why.subIssuance'), {
        app: app?.name ?? '',
      })}
      secondary={{ label: t('embedded.back'), onClick: onBack }}
    />
  );
}
